/*
 * Public API Surface of packaging-waste-management
 */

export * from './pages/packaging-waste-management.component';
export * from './lib/packaging-waste-management.module';
